import { render } from "./EmailSettingPreferences.vue?vue&type=template&id=6efd0e2b&scoped=true"
import script from "./EmailSettingPreferences.vue?vue&type=script&lang=js"
export * from "./EmailSettingPreferences.vue?vue&type=script&lang=js"

import "./EmailSettingPreferences.vue?vue&type=style&index=0&id=6efd0e2b&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6efd0e2b"]])

export default __exports__